



<div class="csv-upload-container">
  <nz-radio-group *ngIf="data?.modalOf === 'usermgmt'" [(ngModel)]="selectMode" [nzButtonStyle]="'solid'" class="mb-lg">
    <label nz-radio nzValue="append">Append</label>
    <label nz-radio nzValue="replace">Replace</label>
  </nz-radio-group>

  <!-- Master Data Upload Dropdowns -->
  <div *ngIf="data?.modalOf === 'masterdata'" class="mb-lg">
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label>Template Type</nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="selectedTemplateType" nzPlaceHolder="Select Template Type"
              (ngModelChange)="onTemplateTypeChange()" class="w100">
              <nz-option *ngFor="let option of templateTypeOptions" [nzLabel]="option.label"
                [nzValue]="option.code"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label>Master Data</nz-form-label>
          <nz-form-control>
            <nz-select [(ngModel)]="selectedMasterData" nzPlaceHolder="Select Master Data"
              (ngModelChange)="onMasterDataChange()" class="w100" nzShowSearch>
              <nz-option *ngFor="let option of filteredMasterDataOptions" 
                [nzLabel]="getTruncatedText(option.description, 20)"
                [nzValue]="option.id"
                [nz-tooltip]="option.description.length > 10 ? option.description : null"
                nzTooltipPlacement="top">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </div>



  <!-- Exchange Rate Date Range -->
  <div *ngIf="data?.modalOf === 'exchangerate'" class="mb-lg">
    <nz-form-item>
      <nz-form-label>Valid From &amp; To <span class="color-red">*</span></nz-form-label>
      <nz-form-control>
        <nz-range-picker nzFormat="dd-MM-yyyy" [(ngModel)]="dateRange" (ngModelChange)="validateDateRange()" class="w100"></nz-range-picker>
        <div *ngIf="!isDateRangeValid && dateRange?.length === 2" class="date-error">
          Start date must be a Monday and end date must be a Sunday, within the same week
        </div>
      </nz-form-control>
    </nz-form-item>
  </div>

  <nz-upload 
    nzType="drag" 
    [nzMultiple]="false" 
    [nzShowUploadList]="false"
    [nzCustomRequest]="customUploadReq" 
   [nzAccept]="data?.fileType === 'csv|excel' ? '.xlsx,.csv': data?.fileType === 'excel' ? '.xlsx' : '.csv'">
    <p class="ant-upload-drag-icon">
      <i nz-icon nzType="inbox"></i>
    </p>
    <p class="ant-upload-text">Click or drag {{data?.fileType === 'excel'? 'Excel': data?.fileType === 'csv'? 'CSV': 'CSV or Excel'}} file to this area to upload</p>
    <p class="ant-upload-hint text-danger">Upload {{data?.fileType === 'excel'? 'Excel (.xlsx)': data?.fileType === 'csv'? 'CSV': 'CSV or Excel (.xlsx)'}} file (Max 1MB)</p>
  </nz-upload>

  <div *ngIf="uploadedFile" class="mt-md">
    <nz-alert nzType="success" nzMessage="File selected: {{uploadedFile.name}}" nzShowIcon></nz-alert>
  </div>

  <div class="sample-files-container" *ngIf="shouldShowDownloadLink()">
    <div class="sample-links">
      <a (click)="downloadSampleFile(data?.fileType)" class="sample-link" [class.disabled]="!selectedMasterData">Download Template {{ getSelectedMasterDataDescription() }} </a>
    </div>
  </div>

  <div class="text-right mt-lg">
    <nz-select [(ngModel)]="defaultFileType" *ngIf="data?.fileType === 'csv|excel' && data?.modalOf === 'usermgmt'" class="mr-sm w80">
      <nz-option [nzValue]="'xlsx'" nzLabel="excel"></nz-option>
      <nz-option [nzValue]="'csv'" nzLabel="csv"></nz-option>
    </nz-select>
    <button nz-button nzType="default" (click)="onCancel()" class="mr-sm">Cancel</button>
    <button nz-button nzType="primary" (click)="onSubmit()" [disabled]="!uploadedFile || (data?.modalOf === 'masterdata' && (!selectedTemplateType || !selectedMasterData)) || (data?.modalOf === 'exchangerate' && (!dateRange || dateRange.length !== 2 || !isDateRangeValid))">Submit</button>
  </div>
</div>
